import { Location } from "react-router-dom";
import isObjectWithKey from "src/utils/isObjectWithKey";

export default function getFrom(location: Location): string | undefined {
  const { state } = location;
  return isObjectWithKey(state, "from") && typeof state.from === "string"
    ? state.from
    : undefined;
}
